import type { IContinueWatchCard } from './ContinueWatchCard.h'

import { Children } from 'react'
import { IconNames, IconSizes } from 'atoms/Icon'
import { LabelFonts } from 'atoms/Label'
import { LabelInlinePrimaryTemplate } from 'atoms/Label/Templates'
import { OverlayLayoutColors } from 'atoms/OverlayLayout'
import { PartnerProgramCoverDesktop } from 'atoms/PartnerProgramCover'
import {
  Card,
  CardAnimations,
  CardCorners,
  ImageBackgroundSC,
} from 'blocks/Cards'
import { TextBlockHorizontalType4 } from 'blocks/TextBlock/Templates'
import { useBooleanState } from 'utils/hooks'
import { COLOR } from 'vars/color'
import { FIXED_INDENTS } from 'vars/fixed-indents'
import { useTvCardBackroundCover } from '../TVCard/lib'
import { ContentLabelSC } from '../TVShowEpisodeCard/TVShowEpisodeCard.styled'
import {
  CardChild,
  CardContent,
  CardStyled,
  CardStyledContent,
  InlinePlaySolidButtonSC,
} from './ContinueWatchCard.styled'
import { ContinueWatchCardProgressBar } from './ContinueWatchCardProgressBar'

export const ContinueWatchCard = ({
  progress,
  childrenTransition = CardAnimations.FadeIn,
  overlayEnabled: _unused1 = true,
  title,
  description,
  durationTitle,
  width,
  height,
  onClick,
  onRemoveCard: _unused2,
  locked,
  lockedTitle: _unused3,
  lockedSizeIcon: _unused4 = IconSizes.xxmLarge,
  lockedColor: _unused5 = COLOR.TEXT_ICON_PRIMARY,
  backgroundColor = COLOR.SURFACE_OPACITY_LIGHT_10,
  titleFont: _unused6,
  padding: _unused7 = FIXED_INDENTS.INDENT_20,
  overlayGradient = OverlayLayoutColors.EPISODE_CARD_VERTICAL_OVERLAY,
  labelFont: _unused8 = LabelFonts.Caption5,
  posterUrl,
  purchaseTitle,
  rented,
  posterHeight: _unused9,
  overlayOnHoverEnabled: _unused10 = true,
  posterWidth: _unused11,
  corners = CardCorners.CORNERS_0,
  backgroundColorHovered: _unused12,
  overlayHeight = '100%',
  children,
  overlayVerticalColor,
  covers,
  lockedIcon = IconNames.tvPinLock,
  ...rest
}: IContinueWatchCard) => {
  const [isPosterLoaded, handlePosterLoading, handlePosterError] =
    useBooleanState(true)

  const posterContent = (
    <ContentLabelSC>
      <LabelInlinePrimaryTemplate title={durationTitle} />

      {progress ? <ContinueWatchCardProgressBar progress={progress} /> : null}
    </ContentLabelSC>
  )

  const poster = isPosterLoaded ? posterUrl : ''
  const emptyPoster = !poster || !isPosterLoaded

  const emptyCover = emptyPoster ? (
    <ImageBackgroundSC>
      <PartnerProgramCoverDesktop />
    </ImageBackgroundSC>
  ) : (
    <></>
  )

  const lockedCover = useTvCardBackroundCover(title, covers)
  const BackgroundCover = locked ? lockedCover : emptyCover
  const childrenList = Children.toArray(children)
  const actionsSlot = childrenList[0]

  return (
    <CardStyled width={width} height={height}>
      <CardStyledContent>
        <Card
          posterUrl={poster}
          width={width}
          hidePriceOnHover={false}
          overlayEnabled={true}
          overlayHeight={overlayHeight}
          overlayVerticalColor={overlayVerticalColor}
          overlayGradient={overlayGradient}
          corners={corners}
          handlePosterLoading={handlePosterLoading}
          handlePosterError={handlePosterError}
          posterContent={posterContent}
          purchaseTitle={purchaseTitle}
          rented={rented}
          locked={locked}
          backgroundCover={BackgroundCover}
          lockedIcon={lockedIcon}
          childrenTransition={childrenTransition}
          onClick={onClick}
          backgroundColor={backgroundColor}
          {...rest}
        >
          <CardChild>
            <CardContent>
              {actionsSlot}
              <InlinePlaySolidButtonSC />
            </CardContent>
          </CardChild>
        </Card>

        <TextBlockHorizontalType4 title={title} description={description} />
      </CardStyledContent>
    </CardStyled>
  )
}
